import React from 'react'

import PageTitle from './PageTitle'

import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles((theme) => ({
    appPageContent: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...theme.globals?.appPageContent,
    },
    appPageBoxContent: {
        flex: "1 auto",
        overflowY: 'auto',
        overflowX: 'hidden',
        ...theme.globals?.appPageBoxContent,
    },
}))

const Content = ({ title, toolbar = null, navigation = null, itemsRules, maxWidth = "xl", children }) => {

    const classes = useStyles()

    return (
        <Container maxWidth={maxWidth} className={classes.appPageContent} >
            <PageTitle 
                title={title}
                toolbar={toolbar}
                navigation={navigation}
                itemsRules={itemsRules}
            />
            <Box className={classes.appPageBoxContent}>
                {children}
            </Box>
        </Container>
    )
}

export default Content